import React, { useEffect, useState, useContext } from "react";
import { returnReshipList } from "../../services/C4S Decommission - Replacement/ReturnReshipList";
import { workTicketList } from "../../services/C4S Decommission - Replacement/workTicketList";
import moment from "moment";
import { C4SContext } from "../../context/c4sContext";
import { DetailedWorkTicketViewMetadata } from "./DetailedWorkTicketView";
import { handleAddPage, switchTab, getInstallType, switchTabAndAddPage } from "./utils";
import { SmallText, Spacer, SLNotification } from "../../components/core/utility";
import { generate } from "shortid";
import useOutsideClick from "../../customHook/use-outside-click";
import { WorkTicketHistoryDetailedViewWTAMetadata } from "./WorkTicketHistoryDetailedViewWTA";
import { updateNewrelicStats } from "../../../utility/newrelic";
import { groupBy, orderBy } from "lodash";

const tableHeader = [
  { name: "ESN", width: "6%" },
  { name: "Hardware", width: "12%" },
  { name: "Bundle ID", width: "7%" },
  { name: "Subscription", width: "10%" },
  { name: "Tech Ref Id", width: "10%" },
  { name: "Work Ticket", width: "10%" },
  { name: "Shipping Address", width: "18%" },
  { name: "Contact", width: "10%" },
  { name: "Return Ticket", width: "10%" },
  { name: "Return Date", width: "10%" },
];

const ReturnedMaterial = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [returnInProgressData, setReturnInProgressData] = useState([]);
  const [returnsReceivedData, setReturnsReceivedData] = useState([]);
  const { notification, isSourceCSP } = useContext(C4SContext);
  const [workTicketListTable, setWorkTicketListTable] = useState([]);

  let caseData = null;
  sessionStorage && sessionStorage.getItem("CSPDetails") ? JSON.parse(sessionStorage.getItem("CSPDetails")) : null;
  caseData =
    sessionStorage && sessionStorage.getItem("CSPDetails")
      ? JSON.parse(sessionStorage.getItem("CSPDetails")).CASEDetails?.filter((caseDetail) => caseDetail.DefaultCase === "1")[0] ?? ""
      : null;

  const handleClickOutside = () => {
    notification.setNotification(null);
  };

  const clickRef = useOutsideClick(handleClickOutside);

  const notify = (content, type) => {
    notification.setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} />);
  };

  const getReturnReshipList = async () => {
    setIsLoading(true);
    try {
      const cspSessionData = JSON.parse(sessionStorage.getItem("CSPDetails"));
      const providerOrder = cspSessionData?.CSP.length ? cspSessionData?.CSP.filter((csp) => csp.DefaultCSP === "1")[0].Provider_Order : "";
      const response = await returnReshipList({ providerOrder });

      if (response.status === 200) {
        const allData = response.data;
        const transformedData = allData?.data?.map((data) => {
          const cspAccountDetails = JSON.parse(sessionStorage.getItem("CSPDetails"));

          return {
            caseNumber: data.caseNumber || "",
            ticketId: data.workTicketId,
            workticketType: data.workTicketType || "",
            migratedRecord: data.workTicketId?.length && data.workTicketId[0] === "W" ? false : true,
            workOrderOwner: data.workOrderOwner,
            installType: data.installType,
            hasEsnToBeReturned: data.hasEsnToBeReturned,
            cityState: `${data?.shippingAddress?.city}, ${data?.shippingAddress?.stateCode}`,
            addressToShow: `${data?.shippingAddress?.address1 || ""} ${data?.shippingAddress?.address2 || ""}${data?.shippingAddress?.city || ""} ${
              data?.shippingAddress?.stateCode || ""
            } ${data?.shippingAddress?.zipCode || ""}  ${data?.shippingAddress?.country || ""}`,
            status: data.wtStatus || "",
            allowCancel: data.allowCancel,
            cancellationReason: data.cancellationReason,
            requestDate: data.requestDate,
            erpTicketType: data.erpTicketType,
            addressOne: data?.shippingAddress?.address1 || "",
            addressTwo: data?.shippingAddress?.address2 || "",
            city: data?.shippingAddress?.city || "",
            stateCode: data?.shippingAddress?.stateCode || "",
            country: data?.shippingAddress?.country || "",
            zipCode: data?.shippingAddress?.zipCode || "",
            workTicket: data.workTicketId,
            contactName: data?.contact?.contactName || "",
            phone: data.contact?.customerPhone || "",
            email: data.contact?.customerEmail || "",
            division: data?.division || null,
            distributionChannel: data?.distributionChannel || null,
            salesOrg: data.salesOrg,
            salesOrderId: data.salesOrderId,
            totalEsnCount: data.totalEsnCount,
            sourceWorkticket: data.sourceWorkticket,
            contractAccount: data.contractAccount,
            assignedTo: data.assignTo,
            crmReferenceId: isSourceCSP.isSourceCSP
              ? cspAccountDetails?.CSP?.length
                ? cspAccountDetails.CSP[0].CRM_Ref_ID
                : null
              : cspAccountDetails?.CASEDetails?.length
              ? cspAccountDetails.CASEDetails[0].CaseNumber
              : null,
            currencyCode: data.currencyCode,
            erpPartnerNumber: cspAccountDetails?.ERP_Partner_Number ?? null,
            erpPrimaryContactNumber: cspAccountDetails?.ERP_Primary_Contact_NUmber ?? null,
            accountName: cspAccountDetails?.AccountName ?? null,
            cspCustomerPONumber: cspAccountDetails?.CSP_CUstomer_PO_Number ?? null,
            subStatus: data.subStatus,
            erpStatus: data.erpStatus,
            wareHouseNotes: data.wareHouseNotes,
            esnNotes: data.esnNotes,
            erpMigrationData: {
              x1ErpSalesRepId: data.x1ErpSalesRepId,
              xcontactMobile: data.xcontactMobile,
              xc4sObjectId: data.xc4sObjectId,
              xschedulingNotes: data.xschedulingNotes,
              xvendorMessage: data.xvendorMessage,
              xnotesToTechnician: data.xnotesToTechnician,
              xfieldNotes: data.xfieldNotes,
              xrequestStartDateTime: data.xrequestStartDateTime,
              xrequestEndDateTime: data.xrequestEndDateTime,
              xvendorId: data.xvendorId,
            },
            ownerName: data.assignedTo,
            originalTicket: data.originalTicket,
            assignedToEid: data.assignedToEid,
            assignedToEmail: data.assignedToEmail,
            createdBy: data.createdBy,
            createdByEid: data.createdByEid,
            createdByEmail: data.createdByEmail,
            createdOn: data.createdAt,
            modifiedAt: data?.modifiedAt ? moment(data.modifiedAt).format("MM/DD/YYYY") : null,
            modifiedBy: data.modifiedBy || "",
            modifiedByEid: data.modifiedByEid || "",
            modifiedByEmail: data.modifiedByEmail || "",
            addressId: data.addressId || "",
            contactId: data.contactId || "",
            wtAddress: data.wtAddress || "",
            assignToName: data.assignToName || "",
            brand: data.brand || "",
            erpCancellationCode: data.erpCancellationCode || "",
            ticketType: data.ticketType || "",
            esn: data.esn || "",
            hardwareId: data.hardwareId || "",
            hardwareName: data.hardwareName || "",
            bundleId: data.bundleId || "",
            subscriptionId: data.subscriptionId || "",
            subscriptionName: data.subscriptionName || "",
            techRefId: data.techRefId || "",
            returnTicket: data.returnTicket || "",
            returnStatus: data.returnStatus || "",
            returnCreated: data.returnCreated || "",
            shippingAddress: data.shippingAddress || "",
            contact: data.contact || "",
          };
        });

        // Filter data based on ReturnStatus
        const inProgressData = transformedData?.filter(
          (item) => item?.returnStatus === "Created" || item?.returnStatus === "Pending Return" || item?.returnStatus === "In Progress"
        );
        const receivedData = transformedData?.filter((item) => item?.returnStatus === "Received");

        setReturnInProgressData(inProgressData);
        setReturnsReceivedData(receivedData);
      }
    } catch (error) {
      notify("We are currently experiencing issues, please try again", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const getWorkTicketList = async () => {
    let cspAccountDetails = null;
    cspAccountDetails = sessionStorage && sessionStorage.getItem("CSPDetails") ? JSON.parse(sessionStorage.getItem("CSPDetails")) : null;
    if (cspAccountDetails === null) return false;
    updateNewrelicStats();
    setIsLoading(true);
    let payLoad = {
      accountId: props?.data?.AccountID,
      cspId:
        isSourceCSP.isSourceCSP && cspAccountDetails?.CSP?.length
          ? cspAccountDetails.CSP.filter((csp) => csp.DefaultCSP === "1")[0].CSPID || null
          : null,
      caseId:
        !isSourceCSP.isSourceCSP && cspAccountDetails?.CASEDetails?.length
          ? cspAccountDetails.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseSFDCID || null
          : null,
    };
    let response = await workTicketList(payLoad);
    if (response.status === 200) {
      let responseWithCityState = response.data.data.map((data) => {
        data.installType = getInstallType(data.installType);
        data.cityState = `${data.city}, ${data.stateCode}`;
        return data;
      });
      let sortedResponse = orderBy(
        responseWithCityState,
        [
          function (o) {
            return new Date(o.modifiedAt);
          },
          function (o) {
            return new Date(o.createdAt);
          },
          "installType",
          "cityState",
        ],
        ["desc", "desc"]
      );
      if (!isSourceCSP.isSourceCSP) {
        let currentCase = groupBy(responseWithCityState, { caseNumber: caseData.CaseNumber }).true ?? [];
        let otherCase = groupBy(responseWithCityState, { caseNumber: caseData.CaseNumber }).false ?? [];
        currentCase = orderBy(
          currentCase,
          function (o) {
            return new Date(o.modifiedAt);
          },
          "desc"
        );
        otherCase = orderBy(
          otherCase,
          function (o) {
            return new Date(o.modifiedAt);
          },
          "desc"
        );
        sortedResponse = [...currentCase, ...otherCase];
      }
      sortedResponse = sortedResponse.map((data) => {
        return {
          caseNumber: data.caseNumber,
          ticketId: data.workticketId,
          workticketType: data.workticketType,
          migratedRecord: data.workticketId?.length && data.workticketId[0] === "W" ? false : true,
          workOrderOwner: data.workOrderOwner,
          installType: data.installType,
          hasEsnToBeReturned: data.hasEsnToBeReturned,
          cityState: `${data.city}, ${data.stateCode}`,
          addressToShow: `${data.addressOne} ${data.addressTwo},${data.stateCode}, ${data.zipCode}`,
          status: data.wtStatus,
          allowCancel: data.allowCancel,
          cancellationReason: data.cancellationReason,
          requestDate: data.requestDate,
          erpTicketType: data.erpTicketType,
          addressOne: data.addressOne,
          addressTwo: data.addressTwo,
          city: data.city,
          stateCode: data.stateCode,
          country: data.country,
          zipCode: data.zipCode,
          workTicket: data.workticketId,
          contactName: data.contactName || "",
          phone: data.phoneNumber || "",
          email: data.emailAddress || "",
          division: data?.division || null,
          distributionChannel: data?.distChannel || null,
          salesOrg: data.salesOrg,
          salesOrderId: data.salesOrderId,
          totalEsnCount: data.totalEsnCount,
          sourceWorkticket: data.sourceWorkticket,
          contractAccount: data.contractAccount,
          assignedTo: data.assignTo,
          crmReferenceId: isSourceCSP.isSourceCSP
            ? cspAccountDetails?.CSP?.length
              ? cspAccountDetails.CSP[0].CRM_Ref_ID
              : null
            : cspAccountDetails?.CASEDetails?.length
            ? cspAccountDetails.CASEDetails[0].CaseNumber
            : null,
          currencyCode: data.currencyCode,
          erpPartnerNumber: cspAccountDetails?.ERP_Partner_Number ?? null,
          erpPrimaryContactNumber: cspAccountDetails?.ERP_Primary_Contact_NUmber ?? null,
          accountName: cspAccountDetails?.AccountName ?? null,
          cspCustomerPONumber: cspAccountDetails?.CSP_CUstomer_PO_Number ?? null,
          subStatus: data.subStatus,
          erpStatus: data.erpStatus,
          wareHouseNotes: data.wareHouseNotes,
          returnReason: data?.returnReason || "",
          returnSubReason: data?.returnSubReason || "",
          esnNotes: data.esnNotes,
          erpMigrationData: {
            x1ErpSalesRepId: data.x1ErpSalesRepId,
            xcontactMobile: data.xcontactMobile,
            xc4sObjectId: data.xc4sObjectId,
            xschedulingNotes: data.xschedulingNotes,
            xvendorMessage: data.xvendorMessage,
            xnotesToTechnician: data.xnotesToTechnician,
            xfieldNotes: data.xfieldNotes,
            xrequestStartDateTime: data.xrequestStartDateTime,
            xrequestEndDateTime: data.xrequestEndDateTime,
            xvendorId: data.xvendorId,
          },
          ownerName: data.assignedTo,
          assignedToEid: data.assignedToEid,
          assignedToEmail: data.assignedToEmail,
          createdBy: data.createdBy,
          createdByEid: data.createdByEid,
          createdByEmail: data.createdByEmail,
          createdOn: data.createdAt,
          modifiedAt: data?.modifiedAt ? moment(data.modifiedAt).format("MM/DD/YYYY") : null,
          modifiedBy: data.modifiedBy,
          modifiedByEid: data.modifiedByEid,
          modifiedByEmail: data.modifiedByEmail,
          addressId: data.addressId,
          contactId: data.contactId,
          returnLabelName: data.returnLabelName || "",
          returnLabelPhone: data.returnLabelPhone || "",
          returnLabelEmail: data.returnLabelEmail || "",
        };
      });
      setWorkTicketListTable(sortedResponse);
    } else {
      notify("We are currently experiencing issues, please try again", "error");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getReturnReshipList();
    getWorkTicketList();
  }, []);

  const handleWorkTicketClick = async (workTicketId, rowData) => {
    WorkTicketHistoryDetailedViewWTAMetadata.name = workTicketId;
    const filteredData = workTicketListTable.find((item) => item.ticketId === workTicketId);
    const enhancedRowData = {
      ...rowData,
      returnLabelEmail: filteredData?.returnLabelEmail || "",
      returnLabelName: filteredData?.returnLabelName || "",
      returnLabelPhone: filteredData?.returnLabelPhone || "",
      returnReason: filteredData?.returnReason || "",
      returnSubReason: filteredData?.returnSubReason || "",
    };
    await switchTabAndAddPage(
      3,
      WorkTicketHistoryDetailedViewWTAMetadata.id,
      {
        data: enhancedRowData,
        AccountID: props?.data?.AccountID,
        ID: props?.data?.ID,
        userId: props?.data?.userId,
      },
      1500
    );
  };

  const handleReturnWorkTicketClick = async (returnTicketId) => {
    const filteredData = workTicketListTable.find((item) => item.ticketId === returnTicketId);
    WorkTicketHistoryDetailedViewWTAMetadata.name = returnTicketId;
    await switchTabAndAddPage(
      3,
      WorkTicketHistoryDetailedViewWTAMetadata.id,
      {
        data: filteredData,
        AccountID: props?.data?.AccountID,
        ID: props?.data?.ID,
        userId: props?.data?.userId,
      },
      1500
    );
  };

  const ReusableTable = (data) => {
    return (
      <table style={{ borderSpacing: "0px", fontFamily: "Verizon-NHG-eTx, Helvetica, Arial, sans-serif", fontSize: "12px" }}>
        <thead>
          <tr style={{ textAlign: "left" }}>
            {tableHeader.map((column, index) => (
              <th key={index} style={{ width: column.width, padding: "10px", borderBottom: "1px solid black" }}>
                {column.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data &&
            data?.map((item, idx) => (
              <tr key={idx} style={{ backgroundColor: idx % 2 !== 0 ? "#F6F6F6" : "#D9D9D9" }}>
                <td>{item.esn}</td>
                <td>
                  <div>{item.hardwareId}</div>
                  <div style={{ marginTop: "4px" }}>{item.hardwareName}</div>
                </td>
                <td>{item.bundleId}</td>
                <td>
                  <div>{item.subscriptionId}</div>
                  <div style={{ marginTop: "4px" }}>{item.subscriptionName}</div>
                </td>
                <td>{item.techRefId}</td>
                <td>
                  <a style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => handleWorkTicketClick(item.originalTicket, item)}>
                    {item.originalTicket}
                  </a>
                  <div style={{ marginTop: "4px" }}>{item.status}</div>
                </td>
                <td>{item?.addressToShow}</td>
                <td>{item?.contact?.customerName}</td>
                <td>
                  <a style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => handleReturnWorkTicketClick(item.returnTicket, item)}>
                    {item.returnTicket}
                  </a>
                </td>
                <td>{item?.returnCreated ? moment(item?.returnCreated).format("MMM D, YYYY") : ""}</td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };
  return (
    <div>
      <h3 style={{ marginBottom: "0px" }}>Return In Progress</h3>
      <p style={{ fontSize: "12px", fontFamily: "Verizon-NHG-eTx, Helvetica, Arial, sans-serif" }}>
        Accessories will remain in &quot;Return in Progress&quot; even after received
      </p>
      {isLoading ? (
        <div>Loading...</div>
      ) : returnInProgressData && returnInProgressData?.length > 0 ? (
        ReusableTable(returnInProgressData)
      ) : (
        <div css={{ textAlign: "center", padding: "20px", fontSize: "14px" }}>
          <SmallText>No data available to display</SmallText>
        </div>
      )}
      <Spacer bottom="25px" />
      <h3>Returns Received</h3>
      {isLoading ? (
        <div>Loading...</div>
      ) : returnsReceivedData && returnsReceivedData?.length > 0 ? (
        ReusableTable(returnsReceivedData)
      ) : (
        <div css={{ textAlign: "center", padding: "20px", fontSize: "14px" }}>
          <SmallText>No data available to display</SmallText>
        </div>
      )}
    </div>
  );
};

export default ReturnedMaterial;
